import React from "react"
import { observer } from "mobx-react-lite"
import { decode } from "js-base64"
import useNavigation from "~hooks/useNavigation"
import { alertError, alertWarning } from "~utils/alert"
import { QrcodeScanner } from "~components/qrcode-scanner"
import { debounceLeading } from "~utils"
import { useStores } from "~models"
import { WakeupDataType } from "~app"
// import { CommonActions } from "@react-navigation/native"

export const QrcodeScan = () => {
  const navigation = useNavigation()
  const { userStore } = useStores()
  return (
    <QrcodeScanner
      onScan={debounceLeading((link) => {
        try {
          if (link == null || String(link).trim() === "") {
            alertWarning({ message: "无法识别该二维码" })
            return
          }
          const raw = String(link).trim()
          const q = raw.indexOf("?")
          const search = q >= 0 ? raw.slice(q + 1) : raw
          const params = search.split("&").reduce((acc, s) => {
            const i = s.indexOf("=")
            if (i === -1) return acc
            const k = decodeURIComponent(s.slice(0, i))
            const v = decodeURIComponent(s.slice(i + 1))
            acc[k] = v
            return acc
          }, {} as WakeupDataType)
          const path = params.path
          const encodedData = params.data
          if (!path || encodedData == null || encodedData === "") {
            alertWarning({ message: "无法识别该二维码（缺少有效内容）" })
            return
          }
          const JsonData = decode(encodedData)
          const data = JSON.parse(JsonData)
          if (path === "contact") {
            const user = data
            if (user) userStore.addUser(user)
            if (user.username === userStore.currentUser.username) {
              alertWarning({ message: "无法添加自己为好友" })
              navigation.goBack()
              return
            }
            navigation.replace("PersonalCard", { userId: user.id })
          } else if (path === "group") {
            const chat = data
            if (chat) {
              navigation.replace("GroupCard", { chat, title: "群聊名片" })
            }
          } else if (path === "channel") {
            const chat = data
            if (chat) {
              navigation.replace("GroupCard", { chat, title: "频道名片" })
            }
          }
        } catch (e) {
          const msg = e instanceof Error ? e.message : String(e)
          alertError({ message: msg || "二维码解析失败" })
        }
      }, 500)}
    />
  )
}

export default observer(QrcodeScan)
